module.exports = __webpack_public_path__ + "static/media/mWebHeroImage.1600359a.png";